export const home = {
  hero: {
    title: 'Automate Your Service Business with AI',
    subtitle: 'VELXIA transforms how service businesses manage customer service. Our AI assistant handles WhatsApp, schedules appointments, and optimizes your processes 24/7.',
    cta: 'Request Demo',
    ctaSecondary: 'Learn More'
  },
  benefits: {
    title: 'Measurable Results from Day One',
    items: [
      {
        title: 'More Reliable Appointments',
        description: 'Automatic reminders and confirmations to reduce no-shows.',
        metric: 'Fewer No-shows'
      },
      {
        title: 'More Confirmed Appointments',
        description: 'Immediate response that converts inquiries into bookings.',
        metric: 'More Bookings'
      },
      {
        title: 'Time Savings',
        description: 'Automate repetitive tasks and free up reception.',
        metric: '15h/week'
      },
      {
        title: 'Immediate Attention',
        description: 'WhatsApp, web and social media: even outside business hours.',
        metric: '24/7'
      },
      {
        title: 'Everything Connected',
        description: 'Calendar, forms and CRM synchronized without duplicating work.',
        metric: 'All in 1'
      },
      {
        title: 'More Satisfied Customers',
        description: 'Follow-up and clear responses that improve customer perception.',
        metric: 'Better Experience'
      }
    ]
  },
  services: {
    title: 'Complete Automation Solutions',
    subtitle: 'Technology for clinics and service businesses: customer service, appointments, processes and lead generation.',
    items: [
      {
        title: 'WhatsApp Assistant',
        description: 'Attends, qualifies and schedules automatically on WhatsApp and social media.',
        link: 'View Details'
      },
      {
        title: 'Smart Calendar',
        description: 'Availability, confirmations and rescheduling integrated with your calendar.',
        link: 'View Details'
      },
      {
        title: 'Converting Websites',
        description: 'Local SEO + forms + WhatsApp + integrated bookings.',
        link: 'View Details'
      },
      {
        title: 'Reminders',
        description: 'Confirmation, reminders and automatic follow-up to reduce no-shows.',
        link: 'View Details'
      },
      {
        title: 'Custom Automation',
        description: 'We design and connect processes to save time and sell more.',
        link: 'View Details'
      }
    ],
    integrations: {
      title: 'Custom Integrations',
      description: 'We connect with Google Calendar and the tools you already use for perfect synchronization'
    }
  },
  howItWorks: {
    title: 'Simple 3-Step Process',
    steps: [
      {
        title: 'Analysis',
        description: 'We study your business and design the perfect solution for your needs'
      },
      {
        title: 'Implementation',
        description: 'We configure and integrate all tools into your workflow'
      },
      {
        title: 'Optimization',
        description: 'We monitor results and continuously improve performance'
      }
    ]
  },
  sectors: {
    title: 'Industries We Work With',
    items: [
      'Aesthetic Centers',
      'Dental Clinics',
      'Veterinary Clinics',
      'Hair Salons',
      'Physiotherapy Centers'
    ]
  },
  ctaFinal: {
    title: 'Ready to Automate Your Business?',
    subtitle: 'Schedule a free consultation and discover how to capture, serve and manage clients with AI.',
    guarantee: 'No commitment • Response within 24h'
  }
};
